/* function inputFile() {
    const uploadedFileList = $("._js-uploaded-file-list");
    const inputFileList = $("#_js-input-file-list");
    let i = 0;


    $(document).on("click", "._js-upload-file", function (e) {
        if (e.detail > 1) {
            return false;
        }

        let element = $("<input/>", {
            type: "file",
            class: "input-file__input",
            name: `files["${i}"]`
        });
        element.appendTo(inputFileList);


        element.on("change", function () {

            if ($(this).val) {
                console.log($(this));
                let uploadedFileName = this.files[0].name;
                uploadedFileList.append(uploadedFile(i, uploadedFileName));
                i++;
            }
        });


    });

    $(document).on("click", "._js-remove-file", function () {
        let id = $(this).attr("data-id");
        let input = $('[name="files[' + id + ']"]');

        $("#" + id).remove();
        input.remove();
    });
}

function uploadedFile(id, name) {
    const upFile = `<div id="${id}" class="attach__item" data-file="${id}">
                        <span data-id="${id}" class="attach__del _js-remove-file">
                        <svg class="icon icon-trash"> <use xlink:href="#trash"></use> </svg>
                        </span>
                        <span class="attachName">${name}</span>
                    </div>`;
    return upFile;
}

inputFile(); */



// Добавление файлов в список
function inputFile() {
	const uploadedFileList = $("._js-uploaded-file-list");
	const inputFileList = $("#_js-input-file-list");
	let i = 0;
	let inputFile = '<input hidden type="file" class="input-file__input" id="0" name="files[0]">';

	$(document).on("click", "._js-upload-file", function (e) {
		if(e.detail > 1) {
			return false;
		}
		let element = $("<input/>", {
			type: "file",
			class: "input-file__input",
			name: "files[" + i + "]"
		});
		element.appendTo(inputFileList);

		element.trigger("click");
		element.on("change", function () {
			if($(this).val) {
				let uploadedFileName = this.files[0].name;
				uploadedFileList.append(uploadedFile(i, uploadedFileName));
				i++;
			}
		});
	});
	$(document).on("click", "._js-remove-file", function () {

		let id = $(this).attr("data-id");
		let input = $('[name="files[' + id + ']"]');

		$("#" + id).remove();
		input.remove();
	});
}

function uploadedFile(id, name) {
	const upFile = '<div id="' + id + '" class="attach__item" data-file="${i}">' + '<span data-id="' + id + '" class="attach__del _js-remove-file">' + '<svg class="icon icon-trash">' + '<use xlink:href="#trash"></use>' + "</svg>" + "</span>" + '<span class="attachName">' + name + "</span>" + "</div>";
	return upFile;
}

inputFile();
